import { type IApiResponse, type IRegister, type IVerifyOtp } from '@/helpers/types';
import { type IUpdateUser } from '@/store/actions/core/auth';

import { coreApiSlice } from '../apiSlice';

/** Body for POST /Auth/register-observer — observer-admin users are not party-bound. */
export interface IRegisterObserver {
	firstName: string;
	lastName: string;
	email: string;
	phoneNumber: string;
	password: string;
	electionObserverId: number;
	governmentDocument: string;
	profilePhoto: string;
}

export const authApiSlice = coreApiSlice.injectEndpoints({
	endpoints: (builder) => ({
		login: builder.mutation<IApiResponse, { email: string }>({
			query: (body) => ({
				method: 'POST',
				url: '/Auth/adminlogin',
				body,
			}),
		}),
		verifyOTPAuth: builder.mutation<IVerifyOtp, { email: string; otp: string }>({
			query: (body) => ({
				method: 'POST',
				url: '/Auth/loginwithotp',
				body,
			}),
		}),
		register: builder.mutation<IApiResponse<{ data: number }>, IRegister>({
			query: (body) => ({
				method: 'POST',
				url: '/Auth/register',
				body,
			}),
		}),
		registerObserver: builder.mutation<IApiResponse, IRegisterObserver>({
			query: (body) => ({
				method: 'POST',
				url: '/Auth/register-observer',
				body,
			}),
		}),
		updateUser: builder.mutation<IApiResponse, { data: IUpdateUser; userId: string }>({
			query: ({ data, userId }) => ({
				method: 'PUT',
				url: `/User/${userId}`,
				body: data,
			}),
		}),
		logoutAllDevices: builder.mutation<IApiResponse, { email: string }>({
			query: (body) => ({
				method: 'POST',
				url: '/Auth/logout/email',
				body,
			}),
		}),
		logout: builder.mutation({
			query: (body) => ({
				method: 'GET',
				url: '/Auth/logout',
				body,
			}),
		}),
		ensureWallet: builder.mutation<unknown, { email: string }>({
			query: (body) => ({
				method: 'POST',
				url: '/Auth/ensure-wallet',
				body,
			}),
		}),
	}),
});

export const {
	useVerifyOTPAuthMutation,
	useLoginMutation,
	useRegisterMutation,
	useRegisterObserverMutation,
	useLogoutAllDevicesMutation,
	useLogoutMutation,
	useUpdateUserMutation,
	useEnsureWalletMutation,
} = authApiSlice;
